<template>
	<div class="landing-page terms">

		<!-- Top navbar -->
		<landing-page-navbar></landing-page-navbar>
		<div class="content-container">
			<div class="content">

				<div class="container" v-if="carrierDetails">
					<div class="row">
						<div class="col-md-10 col-lg-8">
							<dd v-if="carrierDetails.termsLink">
								<span v-html="carrierDetails.termsLink"></span>
							</dd>
							<dd v-else>
								<div class="terms">
									<div class="header">
										<h1>TERMS AND CONDITIONS</h1>
									</div>

									<div class="contain">

										<hr>

										<div v-if="countryCodeSetting === 'UK'">
											<a target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/uk/documents/Likewize_Repair_Limited_Terms.pdf">Click to see our full terms and conditions</a> <img src="https://s3.eu-west-2.amazonaws.com/wefixuk/images/icons/Adobe_PDF_file_icon_32x32.png" alt="Adobe">
<!--											<a target="_blank" href="https://wefix-files.s3.eu-west-2.amazonaws.com/documents/terms/WeFix_Terms_and_Conditions.pdf">Click to see our full terms and conditions</a> <img src="https://s3.eu-west-2.amazonaws.com/wefixuk/images/icons/Adobe_PDF_file_icon_32x32.png" alt="Adobe">-->
										</div>

										<div v-if="countryCodeSetting === 'AU'">
											<a target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/au/documents/Likewize_Repair_Terms_and_Conditions_of_Supply.pdf">Click to see our full terms and conditions</a> <img src="https://s3.eu-west-2.amazonaws.com/wefixuk/images/icons/Adobe_PDF_file_icon_32x32.png" alt="Adobe">

											<hr>

											<a target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/au/documents/Likewize_Repair_Terms_of_Website_Use.pdf">Click to see our terms of website use</a> <img src="https://s3.eu-west-2.amazonaws.com/wefixuk/images/icons/Adobe_PDF_file_icon_32x32.png" alt="Adobe">
										</div>

										<hr>

										<div v-if="carrierDetails.usesKlarna">
											<h3>Klarna Terms</h3>

											<p>In cooperation with Klarna Bank AB (publ), Sveavägen 46, 111 34 Stockholm, Sweden, we offer you the following payment options. Payment is to be made to Klarna:</p>

											<ul>
												<li>Pay later.</li>
												<li>Pay in 3.</li>
											</ul>

											<p>Further information and Klarna’s user terms can be viewed <a href="https://www.klarna.com/uk/terms-and-conditions/" target="_blank">here</a>. General information on Klarna can be found on <a href="https://www.klarna.com/uk/" target="_blank">their website</a>. Your personal data is handled in accordance with applicable data protection law and in accordance with the information in Klarna's <a href="https://www.klarna.com/uk/privacy/" target="_blank">privacy statement</a>.</p>
										</div>
									</div>
								</div>

							</dd>
						</div>
					</div>
				</div>
			</div>
		</div>


		<!-- Footer -->
		<page-footer></page-footer>
	</div>
</template>

<script>
if (process.env.VUE_APP_PARTNER_ENVIRONMENT) {
	require('@/styles/core/whitelabel/'+process.env.VUE_APP_PARTNER_ENVIRONMENT+'.scss');
} else {
	require('@/styles/core/whitelabel/wefix.scss');
}

import {mapGetters} from "vuex";

export default {
	name: "TermsIndex",

	computed: {
		...mapGetters([
			'carrierDetails',
			'countryCodeSetting'
		])
	}
}
</script>

<style scoped>

</style>